// Shared trial-day rules — must stay in sync with backend/server.py `BLOCKED_TRIAL_HOLIDAYS`.
// Australian national public holidays we don't run trials on (ISO YYYY-MM-DD).

export const BLOCKED_TRIAL_HOLIDAYS = new Set([
  // 2026
  "2026-01-01", // New Year's Day
  "2026-01-26", // Australia Day
  "2026-04-03", // Good Friday
  "2026-04-04", // Easter Saturday
  "2026-04-05", // Easter Sunday
  "2026-04-06", // Easter Monday
  "2026-04-25", // ANZAC Day
  "2026-12-25", // Christmas Day
  "2026-12-26", // Boxing Day
  "2026-12-28", // Boxing Day (observed — 26 is a Saturday)
  // 2027
  "2027-01-01", // New Year's Day
  "2027-01-26", // Australia Day
  "2027-03-26", // Good Friday
  "2027-03-27", // Easter Saturday
  "2027-03-28", // Easter Sunday
  "2027-03-29", // Easter Monday
  "2027-04-26", // ANZAC Day (observed — 25 is a Sunday)
  "2027-12-27", // Christmas Day (observed — 25 is a Saturday)
  "2027-12-28", // Boxing Day (observed — 26 is a Sunday)
]);

// State-specific AU public holidays. Must stay in sync with backend `STATE_TRIAL_HOLIDAYS`.
// Only the ones that fall outside the national set — e.g. Labour Day, Melbourne Cup, WA Day.
export const STATE_TRIAL_HOLIDAYS = {
  VIC: new Set([
    "2026-11-03", // Melbourne Cup Day
    "2027-03-08", // Labour Day (2nd Mon Mar)
    "2027-11-02", // Melbourne Cup Day
  ]),
  NSW: new Set([
    "2026-10-05", // Labour Day (1st Mon Oct)
    "2027-10-04", // Labour Day
  ]),
  SA: new Set([
    "2026-10-05", // Labour Day (1st Mon Oct)
    "2027-10-04", // Labour Day
  ]),
  ACT: new Set([
    "2026-10-05", // Labour Day (1st Mon Oct)
    "2027-10-04", // Labour Day
    "2027-05-31", // Reconciliation Day (Mon closest to 27 May)
  ]),
  QLD: new Set([
    "2026-10-05", // King's Birthday (1st Mon Oct)
    "2027-05-03", // Labour Day (1st Mon May)
    "2027-10-04", // King's Birthday
  ]),
  WA: new Set([
    "2026-09-28", // King's Birthday WA (last Mon Sep)
    "2027-03-01", // Labour Day (1st Mon Mar)
    "2027-06-07", // WA Day (1st Mon Jun)
    "2027-09-27", // King's Birthday WA
  ]),
  TAS: new Set([
    "2027-03-08", // Eight Hours Day (2nd Mon Mar)
  ]),
  NT: new Set([
    "2027-05-03", // May Day (1st Mon May)
  ]),
};

// Format a Date object to local YYYY-MM-DD (avoids UTC-offset off-by-one).
export function toISODate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

// A day is blocked if it's a Sunday, a national holiday, or a state-specific holiday.
export function isBlockedTrialDay(d, state) {
  if (!(d instanceof Date) || isNaN(d)) return false;
  if (d.getDay() === 0) return true;
  const iso = toISODate(d);
  if (BLOCKED_TRIAL_HOLIDAYS.has(iso)) return true;
  if (state && STATE_TRIAL_HOLIDAYS[state]?.has(iso)) return true;
  return false;
}

// Build a react-day-picker `disabled` matcher list for the given state.
export function getTrialDayDisabledMatchers(state) {
  const holidays = new Set(BLOCKED_TRIAL_HOLIDAYS);
  if (state && STATE_TRIAL_HOLIDAYS[state]) {
    for (const iso of STATE_TRIAL_HOLIDAYS[state]) holidays.add(iso);
  }
  return [
    { dayOfWeek: [0] },
    ...Array.from(holidays).map((iso) => {
      const [y, m, day] = iso.split("-").map(Number);
      return new Date(y, m - 1, day);
    }),
  ];
}
